/**
 * Authentication Utilities
 *
 * Helper functions for managing authentication data in localStorage.
 * These are utility functions used by components to access current user data.
 */

/**
 * Get the current authenticated user from localStorage
 * Note: With token-only storage, this returns the socialUser object which contains minimal user info (id, username, email, etc.)
 * For full user data, use the AuthContext's user object instead
 * @returns {Object|null} User object or null if not authenticated
 */
export const getCurrentUser = () => {
  const socialUserStr = localStorage.getItem('socialUser');
  return socialUserStr ? JSON.parse(socialUserStr) : null;
};

/**
 * Get the authentication token from localStorage
 * @returns {string|null} Auth token or null if not authenticated
 */
export const getToken = () => {
  return localStorage.getItem('token');
};

/**
 * Check if user is authenticated
 * @returns {boolean} True if user has a token
 */
export const isAuthenticated = () => {
  return !!getToken();
};

/**
 * Clear authentication data from localStorage
 * Note: Only clears tokens, not user data (user data is kept in memory only)
 */
export const clearAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('socialUser');
};
